import { useState, useEffect } from 'react'; 
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { getUrl } from 'aws-amplify/storage'; 
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './navigationBar.css'; 

export default function GuidesMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };    
    
    const [configurationGuideUrl, setConfigurationGuideUrl] = useState("");
    const [taskingGuideUrl, setTaskingGuideUrl] = useState("");
    const [dashboardGuideUrl, setDashboardGuideUrl] = useState("");
    const [urgentTaskingGuideUrl, setUrgentTaskingGuideUrl] = useState("");
    
    useEffect(() => { 
    const getUrlResult = async (key) => {
      try { 
        const url = await getUrl({
          key: key,
          options: {
            accessLevel: 'public',  
            validateObjectExistence: false,  
            expiresIn: 3600
          },
        })  
        return url.url.toString();
      } catch (err) {
        console.log(err);
      }
    } 
    
    const configure  = getUrlResult('userguide.pdf');
    const tasking =  getUrlResult('taskingguide.pdf');
    const dashboard =  getUrlResult('userguide2.pdf');
    const urgent =  getUrlResult('urgenttasking.pdf');
    Promise.all([configure, tasking, dashboard, urgent]).then((values) => {
        setConfigurationGuideUrl(values[0]);
        setTaskingGuideUrl(values[1]);
        setDashboardGuideUrl(values[2]);
        setUrgentTaskingGuideUrl(values[3]);
    }); 
  }, []);

  return ( 
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%',  alignItems: 'center',  }}>
      <Button className='menu-subheader' onClick={handleClick}>
          User&nbsp;Guides
      </Button> 
      <Menu 
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem sx={{fontSize: "15px"}} >
          <a href={configurationGuideUrl} onClick={handleClose} download="configuration_userguide.pdf" target="_blank" rel="noreferrer">Configuration User Guide</a>
        </MenuItem>
        <MenuItem sx={{fontSize: "15px"}}>
          <a href={taskingGuideUrl} onClick={handleClose} download="tasking_userguide.pdf" target="_blank" rel="noreferrer">Tasking User Guide</a>
        </MenuItem>     
        <MenuItem sx={{fontSize: "15px"}}>
          <a href={dashboardGuideUrl} onClick={handleClose} download="dashboard_userguide.pdf" target="_blank" rel="noreferrer">Dashboard User Guide</a>
        </MenuItem>
        <MenuItem sx={{fontSize: "15px"}}>
          <a href={urgentTaskingGuideUrl} onClick={handleClose} download="urgent_tasking_userguide.pdf" target="_blank" rel="noreferrer">Urgent Tasking User Guide</a>
        </MenuItem>
      </Menu>
    </Box>    
  );
} 


// <Button href={userGuideUrl} download="userguide2.pdf" target="_blank" rel="noreferrer" className='nav-feedback-button' variant="outlined">
//                     View Dashboard User Guide
//                   </Button>  
// <AdhocTaskingMenu/>